export default __webpack_public_path__ + "static/newContact-3d0824e0919978d256ad475e4e5a2740.mp4";